const TIME_LIMIT = 600000; //10 minutes

export const saveState = state => {
  try {
    const serializedState = JSON.stringify({
      staticPages: {
        mapDetails: state.staticPages?.mapDetails,
      },
      saveTimestamp: Date.now(),
    });
    const serializedStateForID = JSON.stringify({
      activeForm:{
        activeFormId: state.activeForm?.activeFormId,
      },
    });
    localStorage.setItem('reduxState', serializedState);
    localStorage.setItem('serializedStateForID', serializedStateForID);
  } catch (err) {
    console.error('Error saving state:', err);
  }
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    const serializedStateID = localStorage.getItem('serializedStateForID');
    if (serializedState === null) return undefined;

    const parsedState = JSON.parse(serializedState);
    const parsedStateID = JSON.parse(serializedStateID);
    // clear if TIME_LIMIT milliseconds have passed since the save
    const miliseconds = Date.now() - parsedState.saveTimestamp
    if (miliseconds > TIME_LIMIT) {
      localStorage.removeItem('reduxState');
      return {activeForm:parsedStateID.activeForm,};
    }

    let finalItem = {
      staticPages:parsedState.staticPages,
      activeForm:parsedStateID.activeForm,
    }

    return finalItem;
  } catch (err) {
    console.error('Error loading state:', err);
    return undefined;
  }
};

//maybe for later use
export const getExpiry = () => {
    try {
        const serializedState = localStorage.getItem('reduxState');
        if (serializedState === null) return undefined;
    
        const parsedState = JSON.parse(serializedState);
        const miliseconds = Date.now() - parsedState.saveTimestamp
        if (miliseconds > TIME_LIMIT) {
          localStorage.removeItem('reduxState');
          return undefined;
        }
        return miliseconds;
      } catch (err) {
        console.error('Error getExpiry:', err);
        return undefined;
      }
}
